class CartIcon extends HTMLElement {
  setCount(value) {
    this.countElement = this.querySelector('[data-cart-items-count]');
    value > 0
      ? (this.countElement.textContent = value)
      : (this.countElement.textContent = '0');
  }
}

customElements.get('cart-icon') || customElements.define('cart-icon', CartIcon);
